const FORM_990_DOCUMENT_TYPES = {
  FORM_990: {
    value: "form_990",
    readableName: "Form 990",
  },
  FORM_990_EZ: {
    value: "form_990_ez",
    readableName: "Form 990-EZ",
  },
};

export const form990DocumentTypesArray = Object.values(FORM_990_DOCUMENT_TYPES);
